import { ColumnDef } from "@tanstack/react-table";
import { CSSProperties } from "react";

/**
 * Resolve the inline `width` style for a table column.
 *
 * `meta.width` (CSS string like `"35%"`) takes precedence over `columnDef.size`
 * (pixel number), so callers can opt into container-relative sizing while
 * older tables keep their fixed-pixel layouts.
 */
export function resolveColumnWidthStyle<TData, TValue>(
  columnDef: ColumnDef<TData, TValue>
): CSSProperties | undefined {
  const metaWidth = columnDef.meta?.width;
  if (metaWidth) return { width: metaWidth };
  if (columnDef.size !== undefined) return { width: columnDef.size };
  return undefined;
}
